module.exports = __webpack_public_path__ + "static/media/saxophone.d05d8387.jpg";